import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const diagnosisDataForm: Form<Client> = {
  key: 'diagnosis',
  title: 'Diagnose',
  fields: [
    {
      key: 'eatingDisorder',
      label: 'Art der Essstörung',
      fieldTypes: 'select',
      chart: {
        type: 'bar',
        heading: 'Art der Essstörung',
        options: [
          { label: 'Anorexie', keys: ['anorexia'] },
          { label: 'Bulimie', keys: ['bulimia'] },
          { label: 'Binge Eating', keys: ['bingeEating'] },
          { label: 'Atypische ES', keys: ['aTypicalEatingDisorder'] },
          { label: 'Adipositas', keys: ['adiposity'] },
          { label: 'keine diagn. Einschätzung möglich', keys: ['unknown', 'notSpecified'] },
        ],
      },
      options: [
        {
          value: 'anorexia',
          label: 'Magersucht',
        },
        {
          value: 'bulimia',
          label: 'Bulimie',
        },
        {
          value: 'bingeEating',
          label: 'Binge Eating',
        },
        {
          value: 'aTypicalEatingDisorder',
          label: 'a-typische Essstörung',
        },
        {
          value: 'adiposity',
          label: 'Adipositas',
        },
        {
          value: 'other',
          label: 'Sonstiges',
        },
        {
          value: 'unknown',
          label: 'unbekannt',
        },
      ],
    },
    {
      key: 'otherEatingDisorder',
      label: 'Andere Essstörung',
      fieldTypes: 'text',
      isVisible: (client) => client.eatingDisorder != null && client.eatingDisorder === 'other',
    },
    {
      key: 'perdioOfEatingDisorder',
      label: 'Die Essstörung besteht seit',
      fieldTypes: 'select',
      chart: {
        type: 'bar',
        heading: 'Dauer der Essstörung',
      },
      options: [
        {
          value: 'lessThanAYear',
          label: 'weniger als 1 Jahr',
        },
        {
          value: 'oneTillTwoYears',
          label: '1 - 2 Jahre',
        },
        {
          value: 'threeTillFiveYears',
          label: '3 - 5 Jahre',
        },
        {
          value: 'sixTillTenYears',
          label: '6 - 10 Jahre',
        },
        {
          value: 'elevenTillNineteenYears',
          label: '11 - 19 Jahre',
        },
        {
          value: 'overTwentyYears',
          label: 'Über 20 Jahre',
        },
      ],
    },
    {
      key: 'diagnosis',
      label: 'Andere Diagnose / Komorbidität',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      options: [
        {
          value: 'depression',
          label: 'Depression',
        },
        {
          value: 'borderline',
          label: 'Borderline',
        },
        {
          value: 'trauma',
          label: 'Trauma / PTBS',
        },
        {
          value: 'otherAddictions',
          label: 'Andere Suchterkrankungen',
        },
        {
          value: 'psychosis',
          label: 'Psychose',
        },
        {
          value: 'burnout',
          label: 'Burnout',
        },
        {
          value: 'compulsiveDisorder',
          label: 'Zwangserkrankung',
        },
        {
          value: 'anxietyDisorder',
          label: 'Angststörung',
        },
        {
          value: 'selfHarm',
          label: 'Selbstverletzung',
        },
        {
          value: 'violenceExperience',
          label: 'Gewalterfahrung',
        },
        {
          value: 'formerEatingDisorder',
          label: 'frühere Essstörung',
        },
        {
          value: 'stomachSurgery',
          label: 'Magenoperation',
        },
        {
          value: 'mentalIllness',
          label: 'Psychische Erkrankungen (nicht benannt)',
        },
        {
          value: 'other',
          label: 'Andere',
        },
      ],
    },
    {
      key: 'otherDiagnosis',
      label: 'Andere Diagnose',
      fieldTypes: 'text',
      isVisible: (client) => client.diagnosis != null && client.diagnosis.includes('other'),
    },
  ],
};

export default diagnosisDataForm;
